export default __webpack_public_path__ + "static/media/Thought_Bulb_image.2e72e196.png";